/*
* @author 友人a丶
* @date 2022-07-11
*
* 初始化用户信息
* */


import load from "@/common/load";
import {getConfig, getUserInfo} from "@/service/requests";
import user from "@/stores/user";
import initSystem from '@/stores/system'

export default async function () {


    load.loading("系统正在初始化....");
    console.log("加载用户信息...");


    /* 系统状态 */
    const sys = initSystem();


    const result = await Promise.all([getUserInfo(), getConfig()]); //请求初始化登录
    load.loaded(); //加载完毕

    console.log(result)
    /* 保存全局配置 */
    sys.apply(result[1]);

    /*
    * 系统初始化完毕
    * */
    sys.load();//已初始化

    /*
    * 获取失败
    * 跳转登录界面
    * */
    if (result[0].code) {
        console.log("保存用户信息...........")
        user().save(result[0].user);
        return true;
    }


    return false;

}